import { useState } from 'react';
import { Prompt } from '../../../components/Prompt/Prompt.component';
import { ITaskGroup } from '../../../models/taskGroup.types';
import { createSampleAssessmentGroup } from '../../../services/exams/sampleAssessmentGroup/sampleAssessmentGroup.service';

export const AddSampleAssessmentGroupDialog: React.FC<{
  isAddSampleAssessmentGroupConfirmationVisible: boolean;
  hideAddSampleAssessmentGroupConfirmation: () => void;
  taskGroup: ITaskGroup;
  onReload: () => void;
  onSuccess: () => void;
  onFailure: (isNewSAGCreated: boolean) => void;
}> = (props) => {
  const [isFailurePromptVisible, setIsFailurePromptVisible] = useState<boolean>(false);

  const [errorDuringSampleAssessmentGroupCreation, setErrorDuringSampleAssessmentGroupCreation] =
    useState<boolean>(false);

  const [createdSampleAssessmentGroupId, setCreatedSampleAssessmentGroupId] = useState<string>();

  const createNewSampleAssessmentGroup = () => {
    createSampleAssessmentGroup(props.taskGroup.taskGroupId).then(
      (result) => {
        setCreatedSampleAssessmentGroupId(result.data.id);
        setErrorDuringSampleAssessmentGroupCreation(false);
        props.onReload();
      },
      () => {
        setErrorDuringSampleAssessmentGroupCreation(true);
        setIsFailurePromptVisible(true);
      },
    );
  };

  const getAssignedRoleName = () => {
    return 'Przewodniczącego ZWO';
  };

  const getPromptMainText = () => {
    return errorDuringSampleAssessmentGroupCreation || createdSampleAssessmentGroupId
      ? 'Utworzenie Zespołu Wzorcowych Ocen (ZWO) dla:'
      : `Przypisanie funkcji ${getAssignedRoleName()} Egzaminatorowi:`;
  };

  const getPromptSubTexts = (isSuccess?: boolean) => {
    if (errorDuringSampleAssessmentGroupCreation) {
      return [
        {
          text: props.taskGroup.name,
        },
        {
          text: isSuccess ? 'zakończone sukcesem.' : 'nie powiodło się, spróbuj ponownie później.',
          isBold: true,
        },
      ];
    }
  };

  return (
    <>
      <Prompt
        open={props.isAddSampleAssessmentGroupConfirmationVisible}
        type="confirmation"
        mainText={'Czy na pewno chcesz utworzyć Zespół Wzorcowych Ocen (ZWO) dla:'}
        subTexts={[{ text: props.taskGroup.name }]}
        mainActionButtonText="TAK"
        onCancel={() => {
          props.onFailure(false);
          props.hideAddSampleAssessmentGroupConfirmation();
        }}
        onConfirm={() => {
          props.hideAddSampleAssessmentGroupConfirmation();
          createNewSampleAssessmentGroup();
        }}
      />
      <Prompt
        type="error"
        isBold={true}
        open={isFailurePromptVisible}
        mainText={getPromptMainText()}
        subTexts={getPromptSubTexts()}
        onConfirm={() => {
          props.onFailure(true);
          setIsFailurePromptVisible(false);
        }}
        mainActionButtonText="POWRÓT DO LISTY"
      />
    </>
  );
};
